export default __webpack_public_path__ + "36818283d902313ede3e049c8f1d5cf0.svg";